
var React = require("react");
var ExternalLinkButton = require("./generic/ExternalLinkButton.jsx");
var ApplicationContext = require("../../config/ApplicationContext.js");

class NewPackageButton extends React.Component  {
    constructor(){
        super()
    }

    render(){
        return (
        	<ExternalLinkButton
                text="Create New Package"
                style={{marginBottom: "10px"}}
                onClick={()=>googleGA("send", "event", "packages", "newPackages")}
                link={`${ApplicationContext.getPackageEditor()}?hub=${this.props.idHub}`}
            />
        );
    }
}

module.exports = NewPackageButton;
